import logger from '../logger';
import { assetManagerUtils } from './asset-manager-utils';
import { utils } from '../utils';
import { featureAvaliability } from '../feature-avaliability/feature-avaliability-service';
import { hostCommunicationManager } from '../host-communication';
import { OutgoingMessagesKeys } from '../constants';
import storeCommunicationService from '../store-communication-service/store-communication.service';

const getAsset = async (assetReferenceType, isModelCompare, createAsset, additionalCreationData) => {
  const assets = assetManagerUtils.getAssetSdk();
  if (!assets) {
    return null;
  }

  const rxGuid = utils.getRxGuid(isModelCompare);

  const requestModel = {
    assetReferenceType: assetReferenceType,
    rxId: rxGuid,
  };

  const accessToken = utils.getAccessToken();
  const isCachingEnabled = featureAvaliability.getIsAssetsSdkCachingEnabled();
  const options = {
    forceFetch: !isCachingEnabled,
    saveResponseToCache: isCachingEnabled,
    pinInCache: !isModelCompare,
  };
  const asset = createAsset
    ? await assets.getAndCreateAsset(requestModel, accessToken, additionalCreationData, options)
    : await assets.getAsset(requestModel, accessToken, options);

  return { arrayBuffer: () => asset };
};

const getAssetWithPolling = async (assetReferenceType, isModelCompare) => {
  let asset;

  try {
    asset = await getAsset(assetReferenceType, isModelCompare, true);
    if (asset) {
      return asset;
    }
  } catch (error) {
    if (error && error.statusCode === 401) {
      const appName = 'web-3d-tool';
      const { sessionId } = storeCommunicationService.getStore().context;
      hostCommunicationManager.sendMessageToHost(OutgoingMessagesKeys.TOKEN_EXPIRED, {
        appName: appName,
        eventName: OutgoingMessagesKeys.TOKEN_EXPIRED,
        key: OutgoingMessagesKeys.TOKEN_EXPIRED,
        payload: sessionId,
      });
      return;
    }
    logger
      .error(`fetchItrFileWithPolling: error: ${error}`)
      .data({ module: 'itr-fetcher' })
      .to(['host'])
      .end();
    asset = await assetManagerUtils.pollForAssetCreation(() => getAsset(assetReferenceType, isModelCompare, false));
  }

  if (asset) {
    return asset;
  }

  logger
    .error(`fetchItrFileWithPolling: error: max attempts reached`)
    .data({ module: 'itr-fetcher' })
    .to(['host'])
    .end();

  throw new Error('fetchItrFileWithPolling: Max attempts reached');
};

export const assetManagerRequests = {
  getAsset,
  getAssetWithPolling,
};
